// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__12tqw","productName":"Table_productName__1ucID"};